import React from "react";
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import colors from '../CustomizedUIs/Colors';
import TabPanel from './table-tap-panel';
import TabSend from './table-tab-send';
import TabTemplate from './tab-template';
import TabScheduler from "./tab-scheduler";
import { useTranslate } from 'react-admin';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    position: 'relative'
  },
  selected: {
    backgroundColor: theme.tab.selectedColor,
    width: 190,
    height: 60,
    fontFamily: 'UniviaPro-Bold',
    letterSpacing: '0.44px',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    color: '#ffffff !important'

  },
  tabRoot: {
    width: 190,
    height: 60,
    fontFamily: 'UniviaPro-Bold',
    letterSpacing: '0.44px',
    fontSize: '11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    color: 'rgba(255, 255, 255, 0.7)'

  },
  indicator: {
    backgroundColor: theme.palette.common.white,
    height: 5
  }
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Index({ totalItems, setTotalItems, checkall, isUpdate, isCreate, isDelete }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const translate = useTranslate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
          classes={{
            indicator: classes.indicator
          }}
        >
          <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate('resources.room.send')} {...a11yProps(0)} />
          <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate('pos.messages.templates')} {...a11yProps(1)} />
          <Tab classes={{ root: classes.tabRoot, selected: classes.selected }} label={translate('pos.messages.scheduler')} {...a11yProps(2)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <TabSend isUpdate={isUpdate} isCreate={isCreate} isDelete={isDelete} totalItems={totalItems} setTotalItems={setTotalItems} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <TabTemplate isUpdate={isUpdate} isCreate={isCreate} isDelete={isDelete} totalItems={totalItems} setTotalItems={setTotalItems} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <TabScheduler isUpdate={isUpdate} isCreate={isCreate} isDelete={isDelete} totalItems={totalItems} setTotalItems={setTotalItems} />
      </TabPanel>
    </div>
  );
}

Index.propTypes = {
  setTotalItems: PropTypes.func.isRequired
};

export default Index;
